export default "__VITE_ASSET__b2adecaa__"